export const enum AwardType {
    Gold = 'gold',
    Silver = 'silver',
    Bronze = 'bronze'
}

export interface Award {
    name: string
    value: AwardType
}
